const FACTION_I18N_KEYS = {
  Asrah: 'asrah',
  'Exolot Dominion': 'exolotDominion',
  'League of Shadows': 'leagueOfShadows',
  "Ra's Children": 'rasChildren',
  'Remnants of Humanity': 'remnantsOfHumanity',
  'The Conspiracy': 'theConspiracy',
  'The Corrupted Core': 'theCorruptedCore',
  'The Covenant': 'theCovenant',
  'The Divine Syndicate': 'theDivineSyndicate',
  'The Forsaken Pact': 'theForsakenPact',
  'The Hollow': 'theHollow',
  'The Iron Alliance': 'theIronAlliance',
  'The Last Crusade': 'theLastCrusade',
  'The Shadow Consortium': 'theShadowConsortium',
  'The Silent Accord': 'theSilentAccord',
  'The Sentients': 'theSentients',
};

export function countryTranslationKey(englishName) {
  if (typeof englishName !== 'string' || englishName.length === 0) {
    throw new Error('countryTranslationKey: english country name is required');
  }
  const canonical = englishName === 'Russian Federation' ? 'Russia' : englishName;
  return `countries.${canonical.replace(/\s+/g, '')}`;
}

export function localizeCountryName(englishName, t) {
  if (typeof t !== 'function') {
    throw new Error('localizeCountryName: t is required');
  }
  if (typeof englishName !== 'string' || englishName.length === 0) {
    throw new Error('localizeCountryName: country name is required');
  }
  const cellMatch = englishName.match(/^Cell (\d+)$/);
  if (cellMatch) {
    return t('warEffort.unknownCell', { cellId: cellMatch[1] });
  }
  const key = countryTranslationKey(englishName);
  const translated = t(key);
  if (!translated || translated === key) {
    throw new Error(`localizeCountryName: missing translation for ${englishName} (${key})`);
  }
  return translated;
}

export function localizePurpose(purpose, t) {
  if (typeof t !== 'function') {
    throw new Error('localizePurpose: t is required');
  }
  if (typeof purpose !== 'string' || purpose.length === 0) {
    throw new Error('localizePurpose: purpose is required');
  }
  const key = `warEffort.purposeValues.${purpose.toLowerCase()}`;
  const translated = t(key);
  if (!translated || translated === key) {
    throw new Error(`localizePurpose: missing translation for ${purpose}`);
  }
  return translated;
}

export function localizeFactionName(englishName, t) {
  if (typeof t !== 'function') {
    throw new Error('localizeFactionName: t is required');
  }
  if (typeof englishName !== 'string' || englishName.length === 0) {
    throw new Error('localizeFactionName: faction name is required');
  }
  const suffix = FACTION_I18N_KEYS[englishName];
  if (!suffix) {
    throw new Error(`localizeFactionName: unknown faction ${englishName}`);
  }
  const key = `warEffort.factions.${suffix}`;
  const translated = t(key);
  if (!translated || translated === key) {
    throw new Error(`localizeFactionName: missing translation for ${englishName}`);
  }
  return translated;
}

export function localizeBuildingName(buildingId, t) {
  if (typeof t !== 'function') {
    throw new Error('localizeBuildingName: t is required');
  }
  if (typeof buildingId !== 'string' || buildingId.length === 0) {
    throw new Error('localizeBuildingName: buildingId is required');
  }
  const key = `warEffort.buildings.${buildingId}.name`;
  const translated = t(key);
  if (!translated || translated === key) {
    throw new Error(`localizeBuildingName: missing translation for ${buildingId}`);
  }
  return translated;
}

export function localizeBuildingDescription(buildingId, t, purpose) {
  if (typeof t !== 'function') {
    throw new Error('localizeBuildingDescription: t is required');
  }
  if (typeof buildingId !== 'string' || buildingId.length === 0) {
    throw new Error('localizeBuildingDescription: buildingId is required');
  }
  const isPortal = buildingId === 'portal' || buildingId === 'portal_upgraded';
  const isColonize = purpose != null && String(purpose).trim().toLowerCase() === 'colonize';
  const key = isPortal && isColonize
    ? `warEffort.buildings.${buildingId}.descriptionColonize`
    : `warEffort.buildings.${buildingId}.description`;
  const translated = t(key);
  if (!translated || translated === key) {
    throw new Error(`localizeBuildingDescription: missing translation for ${buildingId}`);
  }
  return translated;
}

export function localizeMissionType(purpose, t) {
  if (typeof t !== 'function') {
    throw new Error('localizeMissionType: t is required');
  }
  if (typeof purpose !== 'string' || purpose.length === 0) {
    throw new Error('localizeMissionType: purpose is required');
  }
  const key = `warEffort.missionTypes.${purpose.toLowerCase()}`;
  const translated = t(key);
  if (!translated || translated === key) {
    throw new Error(`localizeMissionType: missing translation for ${purpose}`);
  }
  return translated;
}
